<template>
<div class="chapter">
<div class="inner_page">
<h2 class="part_no">PART 1</h2>
<p class="fmimageb"><img alt="" src="images/common.jpg"/></p>
<h2 class="part_title">B<span class="small">EING A</span> F<span class="small">IREWORK</span> H<span class="small">UMAN</span></h2>
<p class="image"><img alt="" src="images/part.jpg"/></p>
<p class="indent">As you read this book, I encourage you to understand this: One of the greatest gifts we are given in life is the ability to transform. If we allow ourselves, we can—at any point—decide to make a change. Transformation can happen in a dramatic, sudden way or organically over time. To fight it or stay stuck or complacent is a tragedy for yourself. In the transformation or evolution of ourselves, we discover our magic, our hidden gems, and curiosity starts to bloom, and we become free to be.</p>
<p class="indent">In these first few chapters, I will share what I feel are foundational principles to igniting the sparks to becoming a Firework Human. Embrace new ideas, be encouraged by the familiar, and know that it’s never too late for you to spark—or <i>be</i> the spark in someone else’s journey!</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?5ab79ae6